import {Component} from "@angular/core";
import {EmployeeSearchModel} from "../employee-search.model";
import {EmployeeEntityModel} from "../employee-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-employee-search-page",
    templateUrl: "./employee-search-page.component.html",
    providers: [provideSearchModel(EmployeeSearchModel), provideEntityModel(EmployeeEntityModel)]
})
export class EmployeeSearchPageComponent extends AbstractSearchPage {

    public static EMAIL_REQUIRED_SEARCH_PARAM: string = "emailRequired";

    constructor(public model: EmployeeSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.extendedSearchParams && this.extendedSearchParams.searchParams && this.extendedSearchParams.searchParams[EmployeeSearchPageComponent.EMAIL_REQUIRED_SEARCH_PARAM]) {
            this.model.setFilterValue(EmployeeSearchPageComponent.EMAIL_REQUIRED_SEARCH_PARAM, this.extendedSearchParams.searchParams[EmployeeSearchPageComponent.EMAIL_REQUIRED_SEARCH_PARAM]);
        }
    }
}
